import {
    VerticalBarLineData,
    VerticalBarLineDataBar,
    VerticalBarLineDataBarGroup,
    VerticalBarLineDataBarValue,
    VerticalBarLineDataLine,
    VerticalBarLineDataLinePathPoint,
    VerticalBarLineOptions,
} from '@cmps/ng-chart';

import { Rank, RankHistoryDto, ScorecardDto } from '../../scorecard.model';

interface Publishable {
    isPublished?: boolean;
}

export interface Selectable {
    canBeDeselected?: boolean;
    isSelected?: boolean;
}

export interface RankFilter extends Rank, Selectable {
    maxRankRange: number;
    maxRank: number;
    colour: string;
}

export interface ScorecardPublishStatusFilter extends Selectable {
    name: string;
    isVisible: boolean;
    isPublished: boolean;
}

export interface SuperGroupFilter extends Selectable {
    id: number;
    name: string;
    fullName: string;
    colour: string;
}

export interface TooltipData {
    endDate?: Date;
    startDate?: Date;
    score?: number;
    superGroup?: string;
    ranks?: RankHistoryDto[];
    published?: boolean;
}

// Extended models to handle actions on ScorecardTrendChart

export interface ScorecardTrendChartData {
    verticalBarLineData?: StcVerticalBarLineData;
    showTrendViewOptions?: boolean;
}

export interface StcVerticalBarLineData extends VerticalBarLineData {
    bars: StcVerticalBarLineDataBarGroup[];
    lines: StcVerticalBarLineDataLine[];
}

export interface StcVerticalBarLineDataBarGroup
    extends VerticalBarLineDataBarGroup {
    startDate?: Date;
    endDate?: Date;
    values: StcVerticalBarLineDataBar[];
}

export interface StcVerticalBarLineDataBar
    extends VerticalBarLineDataBar,
        Selectable,
        Publishable {
    groupId: number;
    name: string;
    value: StcVerticalBarLineDataBarValue;
}

export interface StcVerticalBarLineDataBarValue
    extends VerticalBarLineDataBarValue {
    scorecardId?: number;
}

export interface StcVerticalBarLineDataLine extends VerticalBarLineDataLine {
    maxRankValue: number;
    index: number;
}

export interface StcVerticalBarLineDataLinePath {
    key: string;
    colour: string;
    points: VerticalBarLineDataLinePathPoint[];
}

export interface StcVerticalBarLineOptions extends VerticalBarLineOptions {
    barLabel?: (d: StcVerticalBarLineDataBar, i: number) => string;
    barColor?: (d: StcVerticalBarLineDataBar, i: number) => string;
    barPatterned?: (d: StcVerticalBarLineDataBar, i: number) => boolean;
    barSelected?: (
        g: StcVerticalBarLineDataBarGroup,
        d: StcVerticalBarLineDataBar,
        i: number,
    ) => boolean;
}

export interface StcScorecardDto extends ScorecardDto {
    visible?: boolean;
}

export const createEmptyTrendChartData = (): ScorecardTrendChartData => ({});
